import React from 'react';

// Datos de contacto para que el cliente sepa a quién pagarle. Cámbialos aquí.
const CONTACTO = 'carlos22867@gmail.com';

const MENSAJES = {
  pendiente: {
    icono: '⏳',
    titulo: 'Tu cuenta está pendiente de activación',
    texto: 'Hemos recibido tu registro. En cuanto confirmemos el pago activaremos tu acceso.'
  },
  vencida: {
    icono: '📅',
    titulo: 'Tu suscripción venció',
    texto: 'Tus datos siguen guardados. Renueva el pago y volvemos a activarte el acceso.'
  },
  suspendida: {
    icono: '🔒',
    titulo: 'Tu cuenta está suspendida',
    texto: 'Ponte en contacto con nosotros para resolverlo. Tus datos no se han borrado.'
  }
};

export default function CuentaPendiente({ estado, empresa, diasProrroga, onLogout }) {
  const m = MENSAJES[estado] || MENSAJES.pendiente;

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', padding: '20px'
    }}>
      <div style={{
        width: '100%', maxWidth: '460px', background: 'white', borderRadius: '12px',
        padding: '40px', boxShadow: '0 10px 40px rgba(0,0,0,0.2)', textAlign: 'center'
      }}>
        <div style={{ fontSize: '48px', marginBottom: '10px' }}>{m.icono}</div>
        <h2 style={{ margin: '0 0 8px', color: '#1f2937' }}>{m.titulo}</h2>
        {empresa && (
          <p style={{ margin: '0 0 16px', color: '#6b7280', fontSize: '14px' }}>{empresa}</p>
        )}
        <p style={{ color: '#4b5563', fontSize: '15px', lineHeight: 1.5 }}>{m.texto}</p>

        {estado !== 'pendiente' && diasProrroga && (
          <div style={{
            background: '#f0fdf4', color: '#166534', borderRadius: '8px',
            padding: '12px', marginTop: '16px', fontSize: '14px'
          }}>
            🔒 Tus clientes, préstamos y pagos <strong>siguen guardados</strong>.
            Los conservamos {diasProrroga} días desde el vencimiento; al renovar
            los encontrarás tal y como los dejaste.
          </div>
        )}

        <div style={{
          background: '#eef2ff', borderRadius: '8px', padding: '18px',
          margin: '24px 0', textAlign: 'left'
        }}>
          <div style={{ fontWeight: 'bold', color: '#4338ca', marginBottom: '8px', fontSize: '14px' }}>
            📩 Envíanos el comprobante
          </div>
          <div style={{ color: '#4b5563', fontSize: '14px' }}>
            {CONTACTO}
          </div>
          <div style={{ color: '#6b7280', fontSize: '13px', marginTop: '10px' }}>
            Se acepta transferencia o efectivo. En cuanto lo confirmemos, entras
            con este mismo correo y contraseña.
          </div>
        </div>

        <button
          onClick={onLogout}
          style={{
            width: '100%', padding: '12px', borderRadius: '6px', cursor: 'pointer',
            border: '1px solid #e5e7eb', background: 'white', color: '#374151'
          }}
        >
          Cerrar sesión
        </button>
      </div>
    </div>
  );
}
